import {Divider} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import useUser from 'components/GenericsHooks/useUser';
import {Loading} from 'components/grid-dx/loading/loading';
import {DeletingOptions} from 'components/grid-dx/types';
import {i18n2} from 'features/i18n/i18n';
import {Form, Formik} from 'formik';
import React from 'react';
import Signature from '../Editors/Signature';
import {Content, Title} from './index';
import CustomAlert from 'components/grid-dx/alert/';

const Actions = ({setOpen, isSubmitting}: any) => (
  <DialogActions>
    <Button autoFocus onClick={() => setOpen(false)} className="red-text">
      {i18n2._('Cancel')}
    </Button>
    <Button autoFocus type="submit" color="primary" disabled={isSubmitting}>
      {i18n2._('Accept')}
    </Button>
  </DialogActions>
);

interface RemoveProps {
  initialValues?: any;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  row: any | null;
  promise: any;
  text?: string;
  title?: string;
  id: string | Array<string>;
  refresh: any;
}

function PopupRemove({
  initialValues = {},
  open,
  setOpen,
  text,
  title,
  id,
  row = null,
  promise,
  refresh,
}: RemoveProps) {
  const [message, setMessage] = React.useState({
    text: '',
    open: false,
    successful: false,
  });
  const [loading, setLoading] = React.useState(false);

  const submit = (values: any, {setFieldValue, setSubmitting}: any) => {
    if (id.length === 1) {
      const key_1 = id[0];
      values = {
        ...values,
        user: userName,
        id: row[key_1],
      };
    } else if (id.length === 2) {
      const key_1 = id[0];
      const key_2 = id[1];
      values = {
        ...values,
        user: userName,
        key_1: row[key_1],
        key_2: row[key_2],
      };
    } else if (id.length === 3) {
      const key_1 = id[0];
      const key_2 = id[1];
      const key_3 = id[2];
      values = {
        ...values,
        user: userName,
        key_1: row[key_1],
        key_2: row[key_2],
        key_3: row[key_3],
      };
    }

    const deletingOptions: DeletingOptions = {
      row: values,
      additional: null,
    };

    setLoading(true);
    promise(deletingOptions).then((response: any) => {
      if (response.status === 200) {
        setMessage({
          text: i18n2._('Borrado exitosamente'),
          open: true,
          successful: true,
        });
        refresh.current();
        // onClose()
      } else {
        response.text().then((message: any) =>
          setMessage({
            text: response.statusText + ':' + message,
            open: true,
            successful: false,
          }),
        );
        setFieldValue('pass', '');
      }
    });
    setSubmitting(false);
  };

  const userName = useUser();

  const onCloseSnackBar = (successful: boolean) => {
    if (successful) {
      onClose();
    }
    setLoading(false);
  };

  const onClose = () => {
    setOpen(false);
    setLoading(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="customized-dialog-title"
        onClose={onClose}
      >
        <Title title={title} onClose={onClose} />
        <Divider />
        <Content text={text} />
        <Formik
          initialValues={{
            ...initialValues,
          }}
          onSubmit={submit}
          validateOnChange
          enableReinitialize
        >
          {({errors, touched, isSubmitting}) => (
            <Form style={{padding: 15}}>
              <Signature
                user={userName}
                customPadding={null}
                errors={errors}
                touched={touched}
              />
              <Actions setOpen={setOpen} isSubmitting={isSubmitting} />
            </Form>
          )}
        </Formik>
        {loading && <Loading />}
        <CustomAlert
          handleClose={() => onCloseSnackBar(message.successful)}
          message={message.text}
          ms={1000}
          open={message.open}
          successful={message.successful}
        />
      </Dialog>
    </div>
  );
}

export default PopupRemove;
